import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetLaneByCustomerAndLocationsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
  pickupId: Types.Scalars['bigint']['input'];
  deliveryId: Types.Scalars['bigint']['input'];
}>;


export type GetLaneByCustomerAndLocationsQuery = { __typename?: 'query_root', lanes: Array<{ __typename?: 'lanes', id: number, customer_id: number, status?: string | null, enriched_at?: string | null, route_polyline?: string | null, distance_miles?: number | null, duration_sec?: number | null, favorite: boolean, description?: string | null, origin_location_id: number, destination_location_id: number, pickup_inspection_sec?: number | null, delivery_inspection_sec?: number | null, return_ride_wait_sec?: number | null, pickup: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null, region_id?: number | null }, delivery: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null, region_id?: number | null }, inverse?: { __typename?: 'lanes', id: number, customer_id: number, status?: string | null, enriched_at?: string | null, route_polyline?: string | null, distance_miles?: number | null, duration_sec?: number | null, pickup_inspection_sec?: number | null, delivery_inspection_sec?: number | null, return_ride_wait_sec?: number | null, pickup: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null, region_id?: number | null }, delivery: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null, region_id?: number | null } } | null }> };


export const GetLaneByCustomerAndLocationsDocument = gql`
    query getLaneByCustomerAndLocations($customerId: bigint!, $pickupId: bigint!, $deliveryId: bigint!) {
  lanes(
    where: {customer_id: {_eq: $customerId}, origin_location_id: {_eq: $pickupId}, destination_location_id: {_eq: $deliveryId}}
    limit: 1
  ) {
    id
    customer_id
    status
    enriched_at
    route_polyline
    distance_miles
    duration_sec
    favorite
    description
    origin_location_id
    destination_location_id
    pickup_inspection_sec
    delivery_inspection_sec
    return_ride_wait_sec
    pickup {
      id
      name
      address
      latitude
      longitude
      region_id
    }
    delivery {
      id
      name
      address
      latitude
      longitude
      region_id
    }
    inverse {
      id
      customer_id
      status
      enriched_at
      route_polyline
      distance_miles
      duration_sec
      pickup_inspection_sec
      delivery_inspection_sec
      return_ride_wait_sec
      pickup {
        id
        name
        address
        latitude
        longitude
        region_id
      }
      delivery {
        id
        name
        address
        latitude
        longitude
        region_id
      }
    }
  }
}
    `;

/**
 * __useGetLaneByCustomerAndLocationsQuery__
 *
 * To run a query within a React component, call `useGetLaneByCustomerAndLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaneByCustomerAndLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaneByCustomerAndLocationsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      pickupId: // value for 'pickupId'
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
export function useGetLaneByCustomerAndLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetLaneByCustomerAndLocationsQuery, GetLaneByCustomerAndLocationsQueryVariables> & ({ variables: GetLaneByCustomerAndLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaneByCustomerAndLocationsQuery, GetLaneByCustomerAndLocationsQueryVariables>(GetLaneByCustomerAndLocationsDocument, options);
      }
export function useGetLaneByCustomerAndLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaneByCustomerAndLocationsQuery, GetLaneByCustomerAndLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaneByCustomerAndLocationsQuery, GetLaneByCustomerAndLocationsQueryVariables>(GetLaneByCustomerAndLocationsDocument, options);
        }
// @ts-ignore
export function useGetLaneByCustomerAndLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLaneByCustomerAndLocationsQuery, GetLaneByCustomerAndLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLaneByCustomerAndLocationsQuery, GetLaneByCustomerAndLocationsQueryVariables>;
export function useGetLaneByCustomerAndLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLaneByCustomerAndLocationsQuery, GetLaneByCustomerAndLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLaneByCustomerAndLocationsQuery | undefined, GetLaneByCustomerAndLocationsQueryVariables>;
export function useGetLaneByCustomerAndLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLaneByCustomerAndLocationsQuery, GetLaneByCustomerAndLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLaneByCustomerAndLocationsQuery, GetLaneByCustomerAndLocationsQueryVariables>(GetLaneByCustomerAndLocationsDocument, options);
        }
export type GetLaneByCustomerAndLocationsQueryHookResult = ReturnType<typeof useGetLaneByCustomerAndLocationsQuery>;
export type GetLaneByCustomerAndLocationsLazyQueryHookResult = ReturnType<typeof useGetLaneByCustomerAndLocationsLazyQuery>;
export type GetLaneByCustomerAndLocationsSuspenseQueryHookResult = ReturnType<typeof useGetLaneByCustomerAndLocationsSuspenseQuery>;
export type GetLaneByCustomerAndLocationsQueryResult = Apollo.QueryResult<GetLaneByCustomerAndLocationsQuery, GetLaneByCustomerAndLocationsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/schedule/queries/getLaneByCustomerAndLocations.query.gql}
 */
export async function getLaneByCustomerAndLocations(
  variables: GetLaneByCustomerAndLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetLaneByCustomerAndLocationsQuery['lanes']>
export async function getLaneByCustomerAndLocations(
  variables: GetLaneByCustomerAndLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetLaneByCustomerAndLocationsQuery>
export async function getLaneByCustomerAndLocations(
  variables: GetLaneByCustomerAndLocationsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetLaneByCustomerAndLocationsQuery['lanes'] | GetLaneByCustomerAndLocationsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetLaneByCustomerAndLocationsQuery>(
    GetLaneByCustomerAndLocationsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.lanes
}